import type { CrmNotification } from '../types/crm';

const SYSTEM_ONLY_KINDS = new Set([
  'transfer_submitted',
  'transfer_requested',
  'transfer_approved',
  'transfer_rejected',
]);

/** Project / task / approval alerts — prefer OS/browser notification, not in-app toast. */
export function isSystemOnlyCrmNotificationKind(kind: string): boolean {
  const normalized = kind.trim().toLowerCase();
  if (SYSTEM_ONLY_KINDS.has(normalized)) return true;
  return normalized.startsWith('task_') || normalized.startsWith('project_');
}

/** Whether a polled CRM alert should also raise the in-app toast stack. */
export function shouldShowInAppToastForCrmAlert(
  notification: CrmNotification,
  browserNotificationsActive: boolean,
): boolean {
  if (isSystemOnlyCrmNotificationKind(notification.kind)) {
    return false;
  }
  if (browserNotificationsActive) {
    return false;
  }
  return true;
}
